<a [routerLink]="['/devices', 'unassigned']"
   class="btn btn-warning btn-sm rounded-pill shadow-sm text-white fw-bold ps-2 ps-xs-3 border-0">
  <span class="d-none d-sm-inline">Unassigned</span>
  <span class="ms-sm-1 badge text-bg-light rounded-pill">{{ count }}</span>
  <span class="visually-hidden">unassigned devices</span>
</a>